// Vendor
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  backdrop: {
    zIndex: 1500,
    color: '#fff',
  },
  circularProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
  },
}));

export default useStyles;
